import { APPLICATION_STATE, PLATFORM_CODE, QUERY_PARAMS } from './constants';
import { Platform } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import SharedPropsService from '../SharedPropsService';
import { isPartnerAffiliated } from './utils';
export const getParameters = (url) => {
    const params = {};
    const paramString = url.split('?')[1];
    const queryString = (Platform.OS === 'web') ? new URLSearchParams(paramString) : new Map();
    for (const pair of queryString.entries()) {
        params[pair[0].includes('/') ? pair[0].split('/')[1] : pair[0]] =
            pair[1].includes('/') ? pair[1].split('/')[0] : pair[1];
    }
    return params;
};
export const isGoogleLoginEnabled = (user) => {
    if (user.linkedPlatformAccounts[0].platformCode ===
        "SDK_INVESTWELL" /* AppPlatform.SDK_INVESTWELL */) {
        return false;
    }
    else {
        return true;
    }
};
export const shouldShowVoltBrandingSplashScreen = (url, isPlatformQueryPresent) => {
    if (url === '')
        return true;
    const params = getParameters(url);
    if (getPlatformName(params).includes("SDK_INVESTWELL" /* AppPlatform.SDK_INVESTWELL */) || isPlatformQueryPresent) {
        return false;
    }
    else {
        return true;
    }
};
export const areWhatsappUpdatesAllowed = (url) => {
    if (url === '')
        return true;
    const params = getParameters(url);
    if (getPlatformName(params).includes("SDK_INVESTWELL" /* AppPlatform.SDK_INVESTWELL */)) {
        return false;
    }
    else {
        return true;
    }
};
export const shouldShowVoltContactUs = (url) => {
    if (url === '')
        return true;
    const params = getParameters(url);
    if (getPlatformName(params).includes("SDK_INVESTWELL" /* AppPlatform.SDK_INVESTWELL */)) {
        return false;
    }
    else {
        return true;
    }
};
export const getPlatformName = (params) => {
    return params[QUERY_PARAMS.PLATFORM] || '';
};
export const getContactNumberForCall = async (url) => {
    const params = getParameters(url) || {};
    const platformName = getPlatformName(params);
    //@ts-ignore
    let contactSupportNumber;
    const contactNumber = SharedPropsService.getFirebaseConfig().contact_support_number;
    const contactNumberPreDashboard = SharedPropsService.getFirebaseConfig().contact_support_number_pre_dashboard;
    const user = await SharedPropsService.getUser();
    const applicationState = user?.linkedApplications[0]?.applicationState;
    if (await AsyncStorage.getItem("application_id") !== null) {
        contactSupportNumber = contactNumber;
    }
    else if (applicationState === APPLICATION_STATE.IN_PROGRESS) {
        contactSupportNumber = contactNumberPreDashboard;
    }
    else {
        contactSupportNumber = contactNumber;
    }
    if (platformName === "FREO" /* AppPlatform.FREO */) {
        return '+916364465607';
    }
    else if (platformName === "JUPITER" /* AppPlatform.JUPITER */) {
        return '+918655055086';
    }
    else {
        return contactSupportNumber;
    }
};
export const getContactNumberForWhatsapp = async (url) => {
    const params = getParameters(url) || {};
    const platformName = getPlatformName(params);
    const contactNumber = SharedPropsService.getFirebaseConfig().contact_support_number_whatsapp;
    if (platformName === "FREO" /* AppPlatform.FREO */) {
        return '916364465607';
    }
    else if (platformName === "JUPITER" /* AppPlatform.JUPITER */) {
        return '918655055086';
    }
    else {
        return contactNumber;
    }
};
export const getPartnerDashboardConfig = (user, propertyName) => {
    const partnerDashboardConfig = user?.linkedPlatformAccounts[0]?.platformPartnerDashboardConfig;
    if (partnerDashboardConfig === null || partnerDashboardConfig === undefined) {
        return undefined;
    }
    if (partnerDashboardConfig[`${propertyName}`] === true) {
        return true;
    }
    else if (partnerDashboardConfig[`${propertyName}`] === false) {
        return false;
    }
    else
        return undefined;
};
export const showFaq = (user) => {
    const configResult = getPartnerDashboardConfig(user, 'showFaq');
    if (configResult !== undefined) {
        return configResult;
    }
    return true;
};
export const showMFDShareLink = (user) => {
    const configResult = getPartnerDashboardConfig(user, 'showMFDShareLink');
    if (configResult !== undefined) {
        return configResult;
    }
    return true;
};
export const showLogout = (user) => {
    const configResult = getPartnerDashboardConfig(user, 'showLogout');
    if (configResult !== undefined) {
        return configResult;
    }
    return true;
};
export const showVoltLogo = (user) => {
    const configResult = getPartnerDashboardConfig(user, 'showVoltLogo');
    if (configResult !== undefined) {
        return configResult;
    }
    return true;
};
export const showCGS = (user) => {
    const configResult = getPartnerDashboardConfig(user, 'showCGS');
    if (configResult !== undefined) {
        return configResult;
    }
    return true;
};
export const showInterestCalculator = (user) => {
    const configResult = getPartnerDashboardConfig(user, 'showInterestCalculator');
    if (configResult !== undefined) {
        return configResult;
    }
    return true;
};
export const showPendingApplications = (user) => {
    const configResult = getPartnerDashboardConfig(user, 'showPendingApplications');
    if (configResult !== undefined) {
        return configResult;
    }
    return true;
};
export const showCompletedApplications = (user) => {
    const configResult = getPartnerDashboardConfig(user, 'showCompletedApplications');
    if (configResult !== undefined) {
        return configResult;
    }
    return true;
};
export const showDashboard = (user) => {
    const configResult = getPartnerDashboardConfig(user, 'showDashboard');
    if (configResult !== undefined) {
        return configResult;
    }
    return true;
};
export const showDemoVideos = (user) => {
    const configResult = getPartnerDashboardConfig(user, 'showDemoVideos');
    if (configResult !== undefined) {
        return configResult;
    }
    return true;
};
export const showAccountDetails = (user) => {
    const configResult = getPartnerDashboardConfig(user, 'showAccountDetails');
    if (configResult !== undefined) {
        return configResult;
    }
    return true;
};
export const showAboutUs = (user) => {
    const configResult = getPartnerDashboardConfig(user, 'showAboutUs');
    if (configResult !== undefined) {
        return configResult;
    }
    return true;
};
export const showCall = (user) => {
    const partnerDashboardConfig = user?.linkedPlatformAccounts[0]?.platformPartnerDashboardConfig;
    if (partnerDashboardConfig?.csPillData?.showCall == true) {
        return true;
    }
    else if (partnerDashboardConfig?.csPillData?.showCall == false) {
        return false;
    }
    return true;
};
export const showWhatsapp = (user, partnerAccountType) => {
    const partnerDashboardConfig = user?.linkedPlatformAccounts[0]?.platformPartnerDashboardConfig;
    if (partnerDashboardConfig?.csPillData?.showWA == true && !isPartnerAffiliated(partnerAccountType)) {
        return true;
    }
    else if (partnerDashboardConfig?.csPillData?.showWA == false) {
        return false;
    }
    return !isPartnerAffiliated(partnerAccountType);
};
export const showShareLink = (user) => {
    const configResult = getPartnerDashboardConfig(user, 'showShareLink');
    if (configResult !== undefined) {
        return configResult;
    }
    return true;
};
export const isSDKInvestwell = (user) => {
    if (user && user?.linkedPlatformAccounts && user?.linkedPlatformAccounts.length > 0) {
        const platformCode = user?.linkedPlatformAccounts[0]?.platformCode;
        return platformCode === PLATFORM_CODE.SDK_INVESTWELL;
    }
    return false;
};
export const isDefaultPlatform = (user) => {
    if (user && user?.linkedPlatformAccounts && user?.linkedPlatformAccounts.length > 0) {
        const platformCode = user?.linkedPlatformAccounts[0]?.platformCode;
        return platformCode === PLATFORM_CODE.VOLT_WEB_APP || platformCode === PLATFORM_CODE.VOLT_MOBILE_APP;
    }
    return true;
};
export const showContactus = (platform) => {
    if (platform) {
        return platform !== 'REDVISION';
    }
    return true;
};
export const showAccountButton = (platform) => {
    switch (platform) {
        case 'REDVISION':
            return false;
        case "JUPITER":
            return false;
        default:
            return true;
    }
};
export const showVoltPartnerLogo = (platform, user) => {
    return showVoltLogo(user);
};
